export default "__VITE_ASSET__BjXyZ54l__"